import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'
import { useTheme, useMediaQuery, makeStyles } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const useStyles = makeStyles(theme => ({
    elementContent: {},
    smallContent: {
        fontSize: '0.8rem!important',
        color: 'rgba(0,0,0,0.61)!important'
    },
    elementTitle: {
        lineHeight: '1.4rem'
    },
    smallElementTitle: {},
    readMoreIcon: {}
}))

export default function ReadMoreElement({ title, children }) {
    const theme = useTheme()
    const classes = useStyles()
    const [open, setOpen] = useState(true)

    const handleToggle = () => {
        setOpen(!open)
    }

    return (
        <div className={classes.root}>
            <Typography variant="overline" align="left" className={classes.elementTitle + ' ' + classes.smallElementTitle + ' content-element-title'}>
                {title}
            </Typography>
            <Typography variant="body2" align="left" className={classes.elementContent + ' ' + classes.smallContent + ' content-element-description'}>
                {children}
            </Typography>
        </div>
    )
}
